export const appPromoBoxDataHooks = {
  container: 'app-promo-box-container',
};
